import $ from 'jquery';
import 'slick-carousel';

$(window).on('load', function () {
  const $carousel = $('.carousel');

  if ($carousel.find('li').length >= 2) {
    $('.dotSpacer').show();
  }

  $('.carousel').on('init', function () {
    $(this).css('visibility', 'visible');
  });
  $('.carousel').slick({
    dots: true,
    speed: 500,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnFocus: false,
    pauseOnHover: false,
  });
});
